import { useEffect, useState } from 'react';
import './formatter_page.css';

export default function CPSpecialistFormatterPage() {
  const [error, setError] = useState(null);

  // Update this to match your backend's host and port
  const BASE_URL = process.env.REACT_APP_SERVER_URL || '';

  const submitBtn = document.getElementById('submitBtn');
  const statusBox = document.getElementById('status-box');
  
  let timerInterval = null;
  let startTime = null;

  function updateStatus(message, type = 'info', showSpinner = false, showTimer = false) {
      statusBox.style.display = 'block';
      statusBox.className = type;
      
      let htmlContent = `<div>${showSpinner ? '<span class="spinner"></span>' : ''}${message}</div>`;
      
      if (showTimer) {
          htmlContent += `<div class="timer-container">⏱️ Processing time: <span id="timer-display">0.0s</span></div>`;
      }
      
      statusBox.innerHTML = htmlContent;
  }

  function startTimer() {
      startTime = performance.now();
      timerInterval = setInterval(() => {
          const elapsed = ((performance.now() - startTime) / 1000).toFixed(1);
          const display = document.getElementById('timer-display');
          if (display) {
              display.innerText = `${elapsed}s`;
          }
      }, 100);
  }

  function stopTimer() {
      if (timerInterval) {
          clearInterval(timerInterval);
          timerInterval = null;
      }
  }

  async function startWorkflow() {
      const fileInput = document.getElementById('resumeFile');

      if (!fileInput.files[0]) {
          updateStatus("Please select a file to upload.", "error");
          return;
      }

      // Lock UI
      submitBtn.disabled = true;
      
      try {
          updateStatus("Uploading file to server...", "info", true);
          
          const formData = new FormData();
          formData.append("resume", fileInput.files[0]);
          formData.append("filePath", fileInput.files[0].name);

          const uploadResponse = await fetch(`${BASE_URL}/custom/cp-specialist-formatter/upload-resume`, {
              method: 'POST',
              body: formData
          });

          if (!uploadResponse.ok) {
              const errData = await uploadResponse.json();
              throw new Error(errData.error || "Upload failed");
          }

          const uploadResult = await uploadResponse.json();
          const jobId = uploadResult.job_id;
          
          // Start tracking background worker time
          startTimer();
          pollJobStatus(jobId);

      } catch (err) {
          updateStatus(`Workflow Failed: ${err.message}`, "error");
          submitBtn.disabled = false;
      }
  }

  function pollJobStatus(jobId) {
      updateStatus(`Resume queued. Processing background task...`, "info", true, true);

      const pollInterval = setInterval(async () => {
          try {
              // ADDED: Pass headers to bypass ngrok's intercepter page
              const response = await fetch(`${BASE_URL}/custom/cp-specialist-formatter/jobs/${jobId}`, {
                  method: 'GET',
                  headers: {
                      'ngrok-skip-browser-warning': 'true'
                  }
              });
              
              if (!response.ok) {
                  const errData = await response.json();
                  throw new Error(errData.error || "Failed to check status.");
              }

              const jobData = await response.json();
              
              if (jobData.status === 'done') {
                  clearInterval(pollInterval);
                  stopTimer(); 
                  generatePresentation(jobId); // We will need headers here too!
              } else if (jobData.status === 'failed') {
                  clearInterval(pollInterval);
                  stopTimer();
                  throw new Error("The processing engine failed to analyze the document.");
              }

          } catch (err) {
              clearInterval(pollInterval);
              stopTimer();
              updateStatus(`Error: ${err.message}`, "error");
              submitBtn.disabled = false;
          }
      }, 3000);
  }

  async function generatePresentation(jobId) {
      updateStatus("Parsing finished! Compiling presentation...", "info", true, false);

      try {
          const response = await fetch(`${BASE_URL}/custom/cp-specialist-formatter/generate-profile-pptx`, {
              method: 'POST',
              headers: { 
                  'Content-Type': 'application/json',
                  'ngrok-skip-browser-warning': 'true' // ADDED HERE TOO
              },
              body: JSON.stringify({ job_id: jobId })
          });

          if (!response.ok) {
              const errData = await response.json();
              throw new Error(errData.error || "PPTX conversion failed.");
          }

          const blob = await response.blob();
          const downloadUrl = window.URL.createObjectURL(blob);
          
          const a = document.createElement('a');
          a.href = downloadUrl;
          a.download = `profile_output_${jobId}.pptx`;
          document.body.appendChild(a);
          a.click();
          
          document.body.removeChild(a);
          window.URL.revokeObjectURL(downloadUrl);

          updateStatus("🎉 Completed! PowerPoint deck downloaded successfully.", "success");
      } catch (err) {
          updateStatus(`PPTX Error: ${err.message}`, "error");
      } finally {
          submitBtn.disabled = false;
      }
  }


  return (
    <div className="cp-formatter-page">
      <div className="card">
          <h2>Resume PPTX Builder</h2>
          <p className="subtitle">Upload a resume to automatically generate your corporate PowerPoint slide profile.</p>

          <div className="dropzone-area">
              <label htmlFor="resumeFile" style={{ fontWeight: 600, fontSize: '15px', display: 'block' }}>Select Profile File</label>
              <input type="file" id="resumeFile" name="resume" accept=".pdf,.docx" />
          </div>

          <button id="submitBtn" onClick={startWorkflow}>Upload & Process</button>

          <div id="status-box"></div>
      </div>
    </div>
  );
}